module.exports = __webpack_public_path__ + "static/media/edit_black70f20b9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/edit_black.svg
// module id = 232
// module chunks = 0